import {
  GET_RECEPTION_LIST,
  GET_LUNCH_RECEPTION_LIST,
  UPDATE_USER_PRESENCE,
  UPDATE_USER_LUNCH_PRESENCE,
  ERROR_RECEPTION,
  MESSAGE_RECEPTION,
  GET_BADGE,
  SET_RECEPTION_FILTERS
} from "../actions/types"

const initialState = {
  receptionList: [],
  lunchReceptionList: [],
  error: {},
  message: "",
  badge: null,
  filters: {
    search: '',
  }
};

export default function receptionReducer(state = initialState, action) {
  const list = state.receptionList ? [...state.receptionList] : [];
  const lunchList = state.lunchReceptionList ? [...state.lunchReceptionList] : [];
  const index = list?.findIndex((ex) => ex?._id === action.payload?._id);
  const lunchIndex = lunchList?.findIndex((ex) => ex?._id === action.payload?._id);
  switch (action.type) {
    case UPDATE_USER_PRESENCE:
      if (index !== -1) {
        list[index] = {
          ...action.payload,
          company: list[index].company
        };
      }
      return {...state, receptionUser: action.payload, receptionList: list }
    case UPDATE_USER_LUNCH_PRESENCE:
      if (lunchIndex !== -1) {
        lunchList[lunchIndex] = {
          ...action.payload,
          company: lunchList[lunchIndex].company
        };
      }
      return {...state, receptionUser: action.payload, lunchReceptionList: lunchList }
    case GET_RECEPTION_LIST:
      return {...state, receptionList : action.payload}
    case GET_LUNCH_RECEPTION_LIST:
      return {...state, lunchReceptionList : action.payload}
    case SET_RECEPTION_FILTERS:
      return {...state, filters: action.payload}
    case MESSAGE_RECEPTION:
      return {...state, message : action.payload}
    case ERROR_RECEPTION:
      return {...state, error : action.payload}
    case GET_BADGE:
      return {...state, badge : action.payload}
    default:
      return {...state};
  }
}
